import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const AnalyticsInsightReportFeedbackSchema_ = z.object({
  userId: zExt.objectId(),
  feedback: createEnum(["positive", "negative"]),
  comment: z.string().optional(),
});
